import React from "react";
import { Box, CardContent, Grid, Stack, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { SectionCard } from "../styles/StyledComponents";

function BenefitsSection() {
  return (
    <SectionCard sx={{ mb: 4 }}>
      <CardContent sx={{ p: 4 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
          Perché scegliere il nostro servizio?
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "success.main", mt: 0.5 }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Confronto imparziale
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Analisi oggettiva di tutte le offerte disponibili sul
                    mercato
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "success.main", mt: 0.5 }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Risparmio garantito
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    I nostri clienti risparmiano in media 300€ all'anno
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "success.main", mt: 0.5 }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Assistenza dedicata
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Team di esperti a tua disposizione per ogni dubbio
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "success.main", mt: 0.5 }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Cambio semplice
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Ci occupiamo noi di tutte le pratiche burocratiche
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "success.main", mt: 0.5 }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Nessuna interruzione
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Il cambio avviene senza interruzione del servizio
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "success.main", mt: 0.5 }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Energia verde
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Opzioni eco-friendly per un futuro sostenibile
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </SectionCard>
  );
}

export default BenefitsSection;
